//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import Sadasi from '@/api/promotores/sadasi.api'
import Skypark from '@/api/promotores/skypark.api'
import IHM from '@/api/promotores/ihm.api'
import OnisVida from '@/api/promotores/onisvida.api'
import HSBC from '@/api/promotores/hsbc.api'

export default {
	props: {
		title: {
			type: String,
			default: 'Comentarios',
		},

		prospecto_id: {
			type: String,
			required: true,
		},

		organizacion_id: {
			type: String,
			required: true,
			validator(value) {
				return ['ihm', 'skypark', 'onisvida', 'bpb', 'hsbc', 'sadasi'].includes(value)
			}
		},

		comentarios: {
			type: Array,
			required: true
		}
	},
  data() {
    return {
      loading: false,
			comentario: {
				contenido: '',
			},
    }
  },

  methods: {
    show() {
      this.$refs.dialog.show()
    },

    hide() {
      this.$refs.dialog.hide()
    },

    async addComment() {
      try {
        this.loading = true

				const comentario = await this.resolveSender().addComment(this.prospecto_id, this.comentario.contenido);

		
				this.comentario.contenido = '';
        this.$emit('ok', comentario)
      } finally {
        this.loading = false
      }
    },

		resolveSender() {
			return ({
				'sadasi': Sadasi,
				'onisvida': OnisVida,
				'hsbc': HSBC,
				'ihm': IHM,
				'skypark': Skypark
			})[this.organizacion_id]
		}
  }
}
